import { JDSFooterMarketLinksProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFooterMarketLinksProps>
  ): React.FC<JDSFooterMarketLinksProps> =>
  (props: JDSFooterMarketLinksProps) => {
    return <Component {...props} />;
  };
